$(document).ready( function(){
	if ($('.image-gallery__randoms').length > 0){
		var gallery = $('.image-gallery__randoms');
		var hero = gallery.find('.image-gallery__randoms__hero');
		var thumbnail = gallery.find('.image-gallery__randoms__thumbnail');
	    thumbnail.click(function(){
	    	thumbnail.removeClass('current');
	    	$(this).addClass('current');
	    	hero.css({"background-image":'url('+$(this).data('image')+')'});
	    });
	}
});